import { config as CONFIG } from '@platform/api'

/**
 * @desc 获得单元格的唯一Id
 * @param td {dom}
 */

export default function getCellIdentity(td) {
	let div = td.querySelector('div');
	if (div && div.attributes) {
		let attributesArray = Object.values(div.attributes);

		let cellIdentity = attributesArray.find(item => {
			if (item && item.value.startsWith(CONFIG.hotKeyModuleIdPrefix)) {
				return item;
			}
		});

		return cellIdentity && cellIdentity.value;
	}
}
